(function() {
  'use strict';

  angular
    .module('video.youtubeCtrl', [
      'video.youtubeDirective',
      'factories.mobileHelper',
      'factories.utils'
    ])
    .controller('YoutubeCtrl', YoutubeCtrl);

  YoutubeCtrl.$inject = ['$scope', 'Sension', '$rootScope', 'MobileHelper', 'FrameStateProgressHelper', 'Navigation',
    '$timeout', 'SpinnerHelper', 'gettext', 'translationService', '$modal', 'Utils', '$window'];

  function YoutubeCtrl($scope, Sension, $rootScope, MobileHelper, FrameStateProgressHelper, Navigation, $timeout,
                       SpinnerHelper, gettext, translationService, $modal, Utils, $window) {
    var translate = translationService.sprintf;
    var videoState;
    var states;
    var videoControl;

    var pausedWhileEngaged = false;
    var isTrackingProgress = false;
    var hasSetupSensionForVideo = false;

    $scope.yt = null;
    $scope.initYouTubeTimeoutPromise = null;
    $scope.lastLoadStep = 'controller loaded';
    $rootScope.isMuted = $rootScope.isMuted || false;
    $scope.touchMobileHeight = MobileHelper.isTouch() && MobileHelper.isMobileHeight();

    $scope.$watch('mediaState', function(newVideoState) {
      if (!newVideoState) return;
      videoState = newVideoState;
      states = videoState.states;
    });

    $scope.$watch('mediaControl', function(newVideoControl) {
      if (!newVideoControl) return;
      videoControl = newVideoControl;
      videoControl.isPreview = $scope.isPreview;
    });

    $scope.$on('sensionIsEngagedChanged', function() {
      sensionEngagementChanged();
    });

    $scope.$on('$destroy', function() {
      cancelYouTubeInitTimeout();

      if (isTrackingProgress) {
        $scope.calculateTrackProgress();
        FrameStateProgressHelper.updateProgress();
      }
      FrameStateProgressHelper.destroy();

      videoControl.pause();

      if ($scope.yt) {
        if ($scope.yt.destroy)
          $scope.yt.destroy();
        $scope.yt = null;
      }
    });

    $scope.showVideoTapInterceptor = function() {
      return ($scope.hasStartedPlaying && !MobileHelper.willGoNativeFullScreen()) ||
        (Sension.enabled() && !Sension.isEngaged());
    };

    $scope.setupProgressTracking = function() {
      isTrackingProgress = false;
      $timeout(function() {
        if (videoControl.getDuration() > 0) {
          $scope.calculateTrackProgress();

          if (videoControl.trackProgress) {
            isTrackingProgress = true;
            FrameStateProgressHelper.setup({
              cModuleId: $scope.cModuleId,
              frameId: videoControl.slide.id,
              initialProgress: videoControl.slide.progressSeconds
            }, videoControl.getCurrentTime);

            if (videoControl.slide.progressSeconds > 0)
              $scope.seekToProgress();
          }
        } else {
          $scope.setupProgressTracking();
        }
      }, 50);
    };

    $scope.calculateTrackProgress = function() {
      if (!videoControl.getCurrentTime || !videoControl.getDuration)
        return;

      videoControl.slide.progressSeconds = Math.max(videoControl.slide.progressSeconds, Math.floor(videoControl.getCurrentTime()));
      videoControl.trackProgress = !$scope.isPreview && !$scope.completionInfo &&
        //videoControl.slide.status != 117000200 /*Completed*/ &&
        (videoControl.getDuration() - 1) > videoControl.slide.progressSeconds &&
        (Navigation.slideIndex == (Navigation.numUnlockedSlides - 1)) &&
        Navigation.playerType == Navigation.playerTypes.trainee;
    };

    $scope.seekToProgress = function() {
      $timeout(function() {
        if (videoControl.getCurrentTime() < videoControl.slide.progressSeconds) {
          videoControl.seek(videoControl.slide.progressSeconds);
          $scope.seekToProgress();
        }
      }, 100);
    };

    $scope.checkIfCanModifyVolume = function() {
      // We already know whether they can mute so quit.
      if (typeof $rootScope.canMute == 'boolean')
        return;

      // Not as good as actually checking if the volume changes but the YouTube API doesn't make this possible.
      $rootScope.canMute = !MobileHelper.isIOS();
    };

    $scope.onPlayerReady = function() {
      $scope.lastLoadStep = 'youtube player ready';
      cancelYouTubeInitTimeout();

      $timeout($scope.onReadyToStartPlaying, 1);

      videoControl.rawPlay = function() {
        try {
          return $scope.yt.playVideo();
        } catch (err) {
          // Ignore exceptions thrown by YouTube.
        }
      };
      videoControl.rawPause = function() {
        try {
          return $scope.yt.pauseVideo();
        } catch (err) {
          // Ignore exceptions thrown by YouTube.
        }
      };
      videoControl.rawSeek = function(time) {
        try {
          return $scope.yt.seekTo(time, true);
        } catch (err) {
          // Ignore exceptions thrown by YouTube.
        }
      };
      videoControl.canPlay = function() {
        return true;
      };
      videoControl.haveEnoughData = function() {
        return true;
      };
      videoControl.getCurrentTime = function() {
        try {
          return $scope.yt.getCurrentTime();
        } catch (err) {
          // Ignore exceptions thrown by YouTube.
        }
      };
      videoControl.getDuration = function() {
        try {
          return $scope.yt.getDuration();
        } catch (err) {
          // Ignore exceptions thrown by YouTube.
        }
      };
      videoControl.getBufferedPercent = function() {
        try {
          return $scope.yt.getVideoLoadedFraction();
        } catch (err) {
          // Ignore exceptions thrown by YouTube.
        }
      };
      videoControl.toggleMute = function() {
        $rootScope.isMuted = !$rootScope.isMuted;
        setVolume();
      };
      videoControl.requestFullscreen = $scope.requestFullscreen;
      videoControl.exitFullscreen = $scope.exitFullscreen;

      $scope.checkIfCanModifyVolume();

      // Set volume to whatever setting was on previous slide.
      setVolume();

      // only start playing if on desktop or native iPad
      if (!MobileHelper.isMobileDevice())
        videoControl.play();
      else if (MobileHelper.isNativeIpadApp)
        videoControl.play();

      $scope.setupProgressTracking();
    };

    $scope.onPlayerError = function(event) {
      $scope.showGenericContentError();
      throw new Error('Youtube error: ' + Utils.stringifyOnce(event));
    };

    $scope.onPlaying = function() {
      if (!$scope.hasStartedPlaying) {
        $scope.lastLoadStep = 'has started playing';

        // In older versions of IE we can't stop them from being able to click on the video which
        // pauses/plays so at least listen for it and update or state to update the buttons.
        $scope.hasStartedPlaying = true;
      }

      if (!videoState.state || videoState.state == states.paused || videoState.state == states.ended || videoState.state == states.starting) {
        // Media controls, etc. need to know it's playing.
        videoControl.play();
      }

      if (Sension.enabled()) {
        if (!hasSetupSensionForVideo) {
          Sension.mediaSetup({
            identifier: videoControl.slide.id,
            duration: Math.ceil(videoControl.getDuration())
          });
          hasSetupSensionForVideo = true;
        }
        $timeout(function() {
          Sension.mediaPlaying(videoControl.getCurrentTime());
        }, 1);
      }
    };

    $scope.onPaused = function() {
      // In older versions of IE we can't stop them from being able to click on the video which
      // pauses/plays so at least listen for it and update or state to update the buttons.
      if (videoState.state == states.playing)
        videoState.state = states.paused;

      if (Sension.enabled()) {
        pausedWhileEngaged = Sension.isEngaged();
        // Ensure this is asyncronous so that there's not an apply in progress.
        $timeout(function() {
          Sension.mediaPaused(videoControl.getCurrentTime());
        }, 1);
      }
    };

    $scope.showCantLoadYouTubeVideoError = function() {
      cancelYouTubeInitTimeout();
      $scope.contentErrorModal = {
        message: translate(gettext('This content appears to be blocked by your firewall. Please contact your IT Administrator.')),
        redirectToDashboard: true,
        title: translate(gettext('Unable to View Content')),
        url: $window.mfConfig ? $window.mfConfig.cModulenotloadingUrl : mfConfig.cModulenotloadingUrl
      };
      Navigation.state = Navigation.states.ready;
      SpinnerHelper.hideAllSpinners();
      $modal.open({
        templateUrl: 'contentPlayer/contentErrorModal.html',
        controller: 'ContentErrorModal',
        scope: $scope,
        backdrop: 'static'
      });
    };

    function setVolume() {
      if ($rootScope.isMuted)
        $scope.yt.mute();
      else
        $scope.yt.unMute();
    }

    function cancelYouTubeInitTimeout() {
      if ($scope.initYouTubeTimeoutPromise) {
        $timeout.cancel($scope.initYouTubeTimeoutPromise);
        $scope.initYouTubeTimeoutPromise = null;
      }
    }

    function sensionEngagementChanged() {
      if (!Sension.enabled() || !videoControl || !videoControl.play || !videoControl.pause)
        return;

      if (!pausedWhileEngaged && !Sension.faceHidden() && (!Sension.requireEngagement() || Sension.isEngaged())) {
        if (!$scope.hasStartedPlaying)
          $scope.setupProgressTracking();
        videoControl.play();
      } else if (Sension.requireEngagement() || Sension.faceHidden()) {
        videoControl.pause();
      }

      $scope.updateVideoContainerPosition();
    }
  }
})();
